export default __webpack_public_path__ + "static/media/agricole.2ae9bf78.png";